import { withResult } from 'feathers-fletching';
import { disallow } from 'feathers-hooks-common';
import { withSearch } from 'src/feathers/hooks';

const withSearches = withSearch({
  '$shipment.shipper.name$': withSearch.string,
  '$shipment.pickup_address.city$': withSearch.string,
  '$shipment.pickup_address.name$': withSearch.string,
  '$shipment.delivery_address.city$': withSearch.string,
  '$shipment.delivery_address.name$': withSearch.string,
  '$shipment.reference_number$': withSearch.text,
  '$shipment.id$': withSearch.number,
  id: withSearch.number
});

const withResults = withResult({
  charges: async (transfer, context) => {
    if (
      !context.params.$include?.includes('transfer_method') ||
      !transfer.charges?.length
    ) {
      return transfer.charges;
    }

    const chargesWithPayments = await Promise.all(
      transfer.charges.map(async (charge) => {
        const payment = await context.params.loader
          .service('api/transfer-methods')
          .load(charge.transfer_method_id);

        return {
          ...charge,
          transfer_method: payment
        };
      })
    );

    return chargesWithPayments;
  },
  shipment: async (transfer, context) => {
    if (
      !context.params.$include?.includes('shipment') ||
      !transfer.shipment_id
    ) {
      return undefined;
    }

    const shipment = await context.params.loader
      .service('api/shipments')
      .load(transfer.shipment_id);

    return shipment;
  }
});

export default {
  before: {
    all: [withSearches],
    find: [],
    get: [],
    create: [disallow()],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
